import listService from '../services/ListService';
import {
    FELPOT,
    KONNYU_NEGYKEREKU,
    LASSU,
    MEZOGAZD,
    MOTOR,
    MUNKAGEP,
    POTKOCSI,
    SEGEDMOTOR,
    SZGK,
    TEHER,
    BUSZ,
    VONTATO,
    MIKROMOBILITAS, ROLLER,
} from './Gepjarmu';

export const listTypes = {
    penznem: 'penznemList',
    szin: 'szinList',
    waberer_ceg: 'wabererCegList',
    gyerekEv: 'gyerekEv',
    gepj_db: 'gepj_db',
    vannincs: 'vannincs',
    rendelkezem: 'rendelkezem',
    rendelkeztem: 'rendelkeztem',
    casco_egyutt_bizt_list: 'cascoEgyuttkotKedvezmenyBiztList',
    lakas_egyutt_bizt_list: 'lakasEgyuttkotKedvezmenyBiztList',
    gepj_db_waberer: 'gepj_db_waberer',
    mozgaskorlatozott: 'mozgaskorlatozott',
    gepj_db_groupama: 'gepj_db_groupama',
    gepj_db_allianz: 'gepj_db_allianz',
    gepj_db_generali: 'gepj_db_generali',
    gepj_db_genertel: 'gepj_db_genertel',
    gepj_db_aegon: 'gepj_db_aegon',
    gepj_db_signal: 'gepj_db_signal',
    legzsakDb: 'legzsakDb',
    casco_karmentes: 'casco_karmentes',
    elozoBiztEv: 'elozoBiztEv',
    casco_fajta: 'casco_fajta',
    ovb_fajta: 'ovb_fajta',
    motor_fajta: 'motor_fajta',
    teaor: 'teaor25List',
    allampolgarsag: 'allampolgarsagList',
    fizmod: 'fizmodList',
    fizutem: 'fizutemList',
    okmanytipus: 'okmanyTipusList',
    nem: 'szerzodoNemList',
    titulus: 'titulusList',
    orszag: 'orszagList',
    varos: 'varosList',
    gyartmany: 'gyartmanyList',
    ceg: 'cegList',
    felhasznalo: 'felhasznaloList',
    felepitmeny: 'felepitmenyList',
    tipusLista: 'tipusList',
    jarmuFajta: 'fajtaList',
    zerototen: 'zerototen',
    zerotosix: 'zerotosix',
    gyartasiEv: 'gyartasiEv',
    gyartasiEvGap: 'gyartasiEvGap',
    szuletesiEv: 'szuletesiEv',
    miotaGepjarmuUzembenTartoja: 'miotaGepjarmuUzembenTartoja',
    yesno: 'yesno',
    uzembentarto_darab: 'uzembentarto_darab',
    noyes: 'noyes',
    uzemanyag: 'uzemanyagList',
    balesetFedezet: 'balesetFedezetList',
    balesetFedezetListSignal: 'balesetFedezetListSignal',
    balesetFedezetListUniqa: 'balesetFedezetListUniqa',
    balesetFedezetListGenertel: 'balesetFedezetListGenertel',
    balesetFedezetListCIG: 'balesetFedezetListCIG',
    balesetFedezetListUnion: 'balesetFedezetListUnion',
    balesetFedezetListSignalGyerek: 'balesetFedezetListSignalGyerek',
    balesetFedezetListUniqaGyerek: 'balesetFedezetListUniqaGyerek',
    balesetFedezetListGenertelGyerek: 'balesetFedezetListGenertelGyerek',
    balesetFedezetListUnionGyerek: 'balesetFedezetListUnionGyerek',
    termeszetesszemelyNemList: 'termeszetesszemelyNemList',
    unionNeedPartnerPortalList: 'unionNeedPartnerPortalList',
    extrem: 'extremList',
    igazolt: 'igazoltList',
    kedvezmenyezett: 'kedvezmenyezettList',
    cegforma: 'cegformaList',
    bonusMalus: 'bonusMalus',
    cascoBonusz: 'cascoBonusz',
    elozobizt: 'kgfbElozoBiztList',
    aktbizt: 'kgfbAktBiztList',
    mkb_munkahely: 'mkb_munkhely',
    percent: 'percent',
    groupama_munkahely: 'munkahelyList',
    groupama_zoldkartya_igenyles: 'groupamaZoldkartyaIgenylesList',
    hifi_biztosszeg: 'hifi_biztosszeg',
    kerek_biztosszeg: 'kerek_biztosszeg',
    carmodelList: 'carmodelList',
    tulajdonosList: 'tulajdonosList',
    uzemeltetesGapList: 'uzemeltetesGapList',
    tulajdoniviszonyList: 'tulajdoniviszonyList',
    gapFizutemList: 'gapFizutemList',
    biztosito: 'biztositoList',
    gapBiztosito: 'gapBiztositoList',
    nemzetkozi: 'nemzetkozi',
    hasznalatiModList: 'hasznalatiModList',
    kobeDnfelUjrakotottSzerzodesekSzama: 'kobeDnfelUjrakotottSzerzodesekSzama',
};

export const generatedLists = [
    'gyerekEv',
    'gepj_db_signal',
    'gepj_db_aegon',
    'gepj_db_genertel',
    'gepj_db_generali',
    'gepj_db_allianz',
    'gepj_db_groupama',
    'gepj_db_waberer',
    'elozoBiztEv',
    'gyartasiEv',
    'gyartasiEvGap',
    'szuletesiEv',
    'miotaGepjarmuUzembenTartoja',
    'legzsakDb',
    'casco_karmentes',
    'gepj_db',
    'uzembentarto_darab',
    'percent',
    'hifi_biztosszeg',
    'kerek_biztosszeg',
];

export function generateList(type) {
    let list = [];
    let db;
    let gepj;
    const baseYear = new Date().getFullYear();
    switch (type) {
    case 'hifi_biztosszeg':
    case 'kerek_biztosszeg':
        list = [
            {
                key: '0',
                value: 'Nem kérem a kiterjesztést',
            },
            {
                key: '500000',
                value: '500.000 Ft',
            },
            {
                key: '1000000',
                value: '1.000.000 Ft',
            },
        ];
        break;
    case 'percent':
        for (let i = 0; i < 100; i += 1) {
            list.push({
                key: String(i),
                value: `${i} %`,
            });
        }
        break;
    case 'gyartasiEv':
        for (let currentYear = new Date().getFullYear(); currentYear > 1950; currentYear -= 1) {
            list.push({
                key: currentYear,
                value: currentYear,
            });
        }
        break;
    case 'gyartasiEvGap':
        for (let currentYear = new Date().getFullYear(); currentYear > baseYear - 6; currentYear -= 1) {
            list.push({
                key: currentYear,
                value: currentYear,
            });
        }
        break;
    case 'szuletesiEv':
        for (let currentYear = new Date().getFullYear() - 13; currentYear > 1900; currentYear -= 1) {
            list.push({
                key: currentYear,
                value: currentYear,
            });
        }
        break;

        case 'miotaGepjarmuUzembenTartoja':
            for (let currentYear = new Date().getFullYear(); currentYear > 1950; currentYear -= 1) {
                list.push({
                    key: currentYear,
                    value: currentYear,
                });
            }
            break;

    case 'gyerekEv':
        list.push({
            key: 0,
            value: 'Nincs gyermekem, vagy 24 évnél idősebb',
        });
        for (
            let currentYear = new Date().getFullYear();
            currentYear > new Date().getFullYear() - 25;
            currentYear -= 1
        ) {
            list.push({
                key: currentYear,
                value: currentYear,
            });
        } // TODO:: NINCS GYERMEKEM
        // list[0].value = 'Nincs gyermekem, vagy 24 évnél idősebb'
        break;
    case 'elozoBiztEv':
        for (let currentYear = new Date().getFullYear(); currentYear > 1994; currentYear -= 1) {
            list.push({
                key: currentYear,
                value: currentYear,
            });
        }
        break;
    case 'legzsakDb':
        db = 0;
        for (db; db < 7; db += 1) {
            list.push({
                key: db,
                value: `${db} db`,
            });
        }
        list[db - 1].value += ' vagy több';
        break;
    case 'casco_karmentes':
        for (let ev = 0; ev < 11; ev += 1) {
            list.push({
                key: ev,
                value: `${ev} év`,
            });
        }
        break;
    case 'gepj_db':
        gepj = 0;
        for (gepj; gepj < 40; gepj += 1) {
            list.push({
                key: gepj,
                value: `${gepj} db`,
            });
        }
        list[gepj - 1].value += ' vagy több';
        break;
    case 'uzembentarto_darab':
        list.push({
            key: 0,
            value: 'Nem adom meg',
        });
        gepj = 1;
        for (gepj; gepj < 40; gepj += 1) {
            list.push({
                key: gepj,
                value: `${gepj} db`,
            });
        }
        list[gepj - 1].value += ' vagy több';
        break;

    case 'gepj_db_waberer':
        gepj = 0;
        for (gepj; gepj < 12; gepj += 1) {
            list.push({
                key: gepj,
                value: `${gepj} db`,
            });
        }
        list[gepj - 1].value += ' vagy több';
        break;
    case 'gepj_db_allianz':
        gepj = 0;
        for (gepj; gepj < 6; gepj += 1) {
            list.push({
                key: gepj,
                value: `${gepj} db`,
            });
        }
        list[gepj - 1].value += ' vagy több';
        break;
    case 'gepj_db_groupama':
    case 'gepj_db_generali':
    case 'gepj_db_genertel':
    case 'gepj_db_aegon':
    case 'gepj_db_signal':
        gepj = 0;
        for (gepj; gepj < 10; gepj += 1) {
            list.push({
                key: gepj,
                value: `${gepj} db`,
            });
        }
        list[gepj - 1].value += ' vagy több';
        break;
    default:
    }
    return list;
}

export const list = {

    state: {
        lists: {
            gepj_db_waberer: [],
            uzembentarto_darab: [],
            gepj_db_groupama: [],
            gepj_db_allianz: [],
            gepj_db_generali: [],
            gepj_db_genertel: [],
            gepj_db_aegon: [],
            gepj_db_signal: [],
            munkahelyList: [],
            groupamaZoldkartyaIgenylesList: [
                {
                    key: null,
                    value: 'Kérem válasszon!',
                },
                {
                    key: true,
                    value: 'Igen',
                },
                {
                    key: false,
                    value: 'Nem',
                },
            ],
            hifi_biztosszeg: [],
            kerek_biztosszeg: [],
            wabererCegList: [],
            teaorList: [],
            teaor25List: [],
            gyerekEv: [],
            legzsakDb: [],
            gepj_db: [],
            nemzetkozi: [
                {
                    key: 'Igen, csak személyszállításra',
                    value: 'S',
                },
                {
                    key: 'Igen, csak teherfuvarozásra',
                    value: 'T',
                },
                {
                    key: 'Igen, mindkettőre',
                    value: 'Y',
                },
                {
                    key: 'Nem',
                    value: 'N',
                },
            ],
            allampolgarsagList: [],
            allampolgarsag2List: [],
            mozgaskorlatozott: [
                {
                    key: 'N',
                    value: 'Nem',
                },
                {
                    key: 'YM',
                    value: 'Igen és MEOSZ tag',
                },
                {
                    key: 'Y',
                    value: 'Igen és tagja valamelyik mozgáskorlátozott egyesületnek',
                },

            ],
            casco_karmentes: [],
            fizmodList: [],
            fizutemList: [],
            okmanyTipusList: [],
            titulusList: [],
            orszagList: [],
            varosList: [],
            gyartmanyList: [],
            cegList: [],
            cegformaList: [],
            felhasznaloList: [],
            felepitmenyList: [],
            tipusList: [],
            fajtaList: [],
            gyartasiEv: [],
            gyartasiEvGap: [],
            percent: [],
            casco_fajta: [
                {
                    value: 'Személygépkocsi (M1)',
                    key: SZGK,
                },
                {
                    value: 'Teherautó (N1, N2, N3)',
                    key: TEHER,
                },
            ],
            ovb_fajta: [
                {
                    value: 'Személygépkocsi (M1)',
                    key: SZGK,
                },
                {
                    value: 'Teherautó (N1, N2, N3)',
                    key: TEHER,
                },
                {
                    value: 'Motorkerékpár (L3e, L4e, L5e, L7e)',
                    key: MOTOR,
                },
                {
                    value: 'Segédmotor (L1e, L2e)',
                    key: SEGEDMOTOR,
                },
                {
                    value: 'Könnyű Négykerekű Segédmotoros Kerékpár (L6e)',
                    key: KONNYU_NEGYKEREKU,
                },
                {
                    value: 'Pótkocsi, Utánfutó (O1, O2, O3, O4, R1, R2, R3, R4)',
                    key: POTKOCSI,
                },
                {
                    value: 'Lassú Jármű (Lj, T0)',
                    key: LASSU,
                },
                {
                    value: 'Mezőgazdasági Vontató (T1, T2, T3, T4, T5)',
                    key: MEZOGAZD,
                },
                {
                    value: 'Autóbusz (M2, M3)',
                    key: BUSZ,
                },
                {
                    value: 'Vontató (N1, N2, N3)',
                    key: VONTATO,
                },
                {
                    value: 'Munkagép (S1, S2)',
                    key: MUNKAGEP,
                },
                {
                    value: 'Félpótkocsi',
                    key: FELPOT,
                },
                {
                    value: 'Egyéb mikromobilitási eszköz',
                    key: MIKROMOBILITAS,
                },
                {
                    value: 'Elektromos roller',
                    key: ROLLER,
                },
            ],
            motor_fajta: [
                {
                    value: 'Segédmotor (L1e, L2e)',
                    key: SEGEDMOTOR,
                },
                {
                    value: 'Motorkerékpár (L3e, L4e, L5e, L7e)',
                    key: MOTOR
                },
                {
                    value: 'Könnyű Négykerekű Segédmotoros Kerékpár (L6e)',
                    key: KONNYU_NEGYKEREKU,
                },
            ],
            kgfbElozoBiztList: [],
            kgfbAktBiztList: [],
            cascoEgyuttkotKedvezmenyBiztList: [],
            lakasEgyuttkotKedvezmenyBiztList: [],
            szuletesiEv: [],
            miotaGepjarmuUzembenTartoja: [],
            uzemanyagList: [],
            elozoBiztEv: [],
            szinList: [],
            zerototen: [
                {
                    key: 0,
                    value: 0,
                },
                {
                    key: 1,
                    value: 1,
                },
                {
                    key: 2,
                    value: 2,
                },
                {
                    key: 3,
                    value: 3,
                },
                {
                    key: 4,
                    value: 4,
                },
                {
                    key: 5,
                    value: 5,
                },
                {
                    key: 6,
                    value: 6,
                },
                {
                    key: 7,
                    value: 7,
                },
                {
                    key: 8,
                    value: 8,
                },
                {
                    key: 9,
                    value: 9,
                },
                {
                    key: 10,
                    value: 10,
                },
            ],
            zerotosix: [
                {
                    key: 0,
                    value: 0,
                },
                {
                    key: 1,
                    value: 1,
                },
                {
                    key: 2,
                    value: 2,
                },
                {
                    key: 3,
                    value: 3,
                },
                {
                    key: 4,
                    value: 4,
                },
                {
                    key: 5,
                    value: 5,
                },
                {
                    key: 6,
                    value: 6,
                },
            ],
            yesno: [
                {
                    value: true,
                    key: 'Igen',
                },
                {
                    value: false,
                    key: 'Nem',
                },
            ],
            noyes: [
                {
                    value: false,
                    key: 'Nem',
                },
                {
                    value: true,
                    key: 'Igen',
                },
            ],
            vannincs: [
                {
                    value: true,
                    key: 'Rendelkezem ilyen járművel',
                },
                {
                    value: false,
                    key: 'Nem rendelkezem ilyen járművel',
                },
            ],
            rendelkezem: [
                {
                    value: true,
                    key: 'Rendelkezem',
                },
                {
                    value: false,
                    key: 'Nem rendelkezem',
                },
            ],
            rendelkeztem: [
                {
                    value: true,
                    key: 'Rendelkeztem',
                },
                {
                    value: false,
                    key: 'Nem rendelkeztem',
                },
            ],
            szerzodoNemList: [],
            fizModList: [],
            fizUtemList: [],
            balesetFedezetList: [
                {
                    key: 1,
                    value: 'Bázis',
                },
                {
                    key: 2,
                    value: 'Standard',
                },
                {
                    key: 3,
                    value: 'Prémium',
                },
            ],
            balesetFedezetListSignal: [
                {
                    key: 1,
                    value: 'Bázis',
                },
                {
                    key: 2,
                    value: 'Médium',
                },
                {
                    key: 3,
                    value: 'Prémium',
                },
                {
                    key: 5,
                    value: 'Szingli',
                },
            ],
            balesetFedezetListUniqa: [
                {
                    key: 1,
                    value: 'Bázis',
                },
                {
                    key: 2,
                    value: 'Standard',
                },
                {
                    key: 3,
                    value: 'Optimum',
                },
            ],
            balesetFedezetListCIG: [
                {
                    key: 1,
                    value: 'Alap',
                },
                {
                    key: 2,
                    value: 'Emelt',
                },
            ],
            balesetFedezetListGenertel: [
                {
                    key: 1,
                    value: 'Mini',
                },
                {
                    key: 2,
                    value: 'Classic',
                },
                {
                    key: 3,
                    value: 'Plus',
                },
                {
                    key: 4,
                    value: 'Extra',
                },
            ],
            balesetFedezetListUnion: [
                {
                    key: 4,
                    value: 'Prémium',
                },
                {
                    key: 1,
                    value: 'Standard',
                },
                {
                    key: 6,
                    value: 'Light',
                },
                {
                    key: 5,
                    value: 'Extrém sport',
                },
                {
                    key: 2,
                    value: 'Flexi',
                },
                {
                    key: 3,
                    value: 'Fun',
                },
            ],
            balesetFedezetListSignalGyerek: [
                {
                    key: 1,
                    value: 'Bázis',
                },
                {
                    key: 2,
                    value: 'Médium',
                },
                {
                    key: 3,
                    value: 'Prémium',
                },
                {
                    key: 4,
                    value: 'Gyerek',
                },
                {
                    key: 5,
                    value: 'Szingli',
                },
            ],
            balesetFedezetListUniqaGyerek: [
                {
                    key: 4,
                    value: 'Gyerek',
                },
            ],
            penznemList: [
                {
                    key: 0,
                    value: 'Ft',
                },
                {
                    key: 1,
                    value: 'CHF',
                },
                {
                    key: 2,
                    value: 'EUR',
                },
                {
                    key: 3,
                    value: 'JPY',
                },
                {
                    key: 4,
                    value: 'USD',
                },
            ],
            balesetFedezetListGenertelGyerek: [
                {
                    key: 5,
                    value: 'Gyerek',
                },
            ],
            balesetFedezetListUnionGyerek: [
                {
                    key: 1,
                    value: 'egy gyermek sem biztosított',
                },
                {
                    key: 2,
                    value: 'egy gyermek biztosított',
                },
                {
                    key: 3,
                    value: 'kettő vagy több gyermek biztosított',
                },
            ],
            balesetFedezetListUnionGyerekOrFelnott: [
                {
                    key: 1,
                    value: 'Gyerek csomag',
                },
                {
                    key: 2,
                    value: 'Felnőtt csomag (16 év felett)',
                },
            ],
            termeszetesszemelyNemList: [
                {
                    key: 1,
                    value: 'Férfi',
                },
                {
                    key: 2,
                    value: 'Nő',
                },
            ],
            unionNeedPartnerPortalList: [
                {
                    key: 1,
                    value: 'Nem kérek',
                },
                {
                    key: 2,
                    value: 'Igen kérek',
                },
                {
                    key: 3,
                    value: 'Már rendelkezem',
                },
            ],
            extremList: [
                {
                    key: 1,
                    value: 'Nem',
                },
                {
                    key: 2,
                    value: 'Igen',
                },
            ],
            igazoltList: [
                {
                    key: 1,
                    value: 'Nem',
                },
                {
                    key: 2,
                    value: 'Igen',
                },
            ],
            kedvezmenyezettList: [
                {
                    key: 1,
                    value: 'Törvényes örökös(ök)',
                },
                {
                    key: 2,
                    value: 'Törvényes örököstől eltérő személy',
                },
            ],
            bonusMalus: [
                {
                    key: '10',
                    value: 'B10',
                },
                {
                    key: '9',
                    value: 'B9',
                },
                {
                    key: '8',
                    value: 'B8',
                },
                {
                    key: '7',
                    value: 'B7',
                },
                {
                    key: '6',
                    value: 'B6',
                },
                {
                    key: '5',
                    value: 'B5',
                },
                {
                    key: '4',
                    value: 'B4',
                },
                {
                    key: '3',
                    value: 'B3',
                },
                {
                    key: '2',
                    value: 'B2',
                },
                {
                    key: '1',
                    value: 'B1',
                },
                {
                    key: '0',
                    value: 'A0',
                },
                {
                    key: '-1',
                    value: 'M1',
                },
                {
                    key: '-2',
                    value: 'M2',
                },
                {
                    key: '-3',
                    value: 'M3',
                },
                {
                    key: '-4',
                    value: 'M4',
                },
            ],

            cascoBonusz: [
                {
                    key: '-1',
                    value: 'Még nem volt CASCO szerződésem',
                },
                {
                    key: '0',
                    value: 'C0',
                },
                {
                    key: '1',
                    value: 'C1',
                },
                {
                    key: '2',
                    value: 'C2',
                },
                {
                    key: '3',
                    value: 'C3',
                },
                {
                    key: '4',
                    value: 'C4',
                },
                {
                    key: '5',
                    value: 'C5',
                },
                {
                    key: '6',
                    value: 'C6',
                },
                {
                    key: '7',
                    value: 'C7',
                },
                {
                    key: '8',
                    value: 'C8',
                },
                {
                    key: '9',
                    value: 'C9',
                },
                {
                    key: '10',
                    value: 'C10',
                },
            ],

            mkb_munkhely: [
                {
                    key: -1,
                    value: 'Egyéb',
                },
                {
                    key: 11,
                    value: 'Egyéni vállalkozó',
                },
                {
                    key: 5,
                    value: 'Kormánytisztviselő',
                },
                {
                    key: 3,
                    value: 'Közalkalmazott',
                },
                {
                    key: 4,
                    value: 'Köztisztviselő',
                },
                {
                    key: 1,
                    value: 'MKB csoport alkalmazott',
                },
                {
                    key: 6,
                    value: 'Pedagógus',
                },
                {
                    key: 7,
                    value: 'Repiva tag takarékszövetkezeti alkalmazott',
                },
                {
                    key: 10,
                    value: 'Ügyvédi kamara tagja',
                },
                {
                    key: 12,
                    value: 'Vállalkozó max. 10 alkalmazottal',
                },
                {
                    key: 13,
                    value: 'Őstermelő',
                },
            ],

            carmodelList: [],

            tulajdonosList: [
                {
                    key: 1,
                    value: 'Szerződő',
                },
                {
                    key: 2,
                    value: 'Lízingcég',
                },
                {
                    key: 3,
                    value: 'Bank',
                },
                {
                    key: 4,
                    value: 'Egyéb',
                },
            ],

            uzemeltetesGapList: [
                {
                    key: 1,
                    value: 'Személygépjármű (M1)',
                },
            ],

            tulajdoniviszonyList: [
                {
                    key: 1,
                    value: 'Saját tulajdon',
                },
                {
                    key: 2,
                    value: 'Tartós bérlet (operatív lízing)',
                },
                {
                    key: 3,
                    value: 'Pénzügyi lízing',
                },
            ],

            gapFizutemList: [
                {
                    key: 1,
                    value: 'Havi',
                },
                {
                    key: 2,
                    value: 'Negyedéves',
                },
                {
                    key: 3,
                    value: 'Féléves',
                },
                {
                    key: 4,
                    value: 'Éves',
                },
                {
                    key: 5,
                    value: 'Egyösszegű',
                },
            ],

            gapTartamList: [
                {
                    key: 1,
                    value: '1 év',
                },
                {
                    key: 2,
                    value: '2 év',
                },
                {
                    key: 3,
                    value: '3 év',
                },
                {
                    key: 4,
                    value: '4 év',
                },
                {
                    key: 5,
                    value: '5 év',
                },
            ],
            biztositoList: [],
            gapBiztositoList: [],
            hasznalatiModList: [],
            kobeDnfelUjrakotottSzerzodesekSzama: [
                {
                    value: '0',
                    key: '0 db',
                },
                {
                    value: '1',
                    key: '1 db',
                },
                {
                    value: '2',
                    key: '2 db',
                },
                {
                    value: '3',
                    key: '3 db',
                },
                {
                    value: '4',
                    key: '4 db',
                },
                {
                    value: '5',
                    key: '5 db',
                },
                {
                    value: '6',
                    key: '6 db, vagy annál több',
                },
            ],

        },
    },

    getters: {
        lists: (state) => state.lists,
    },

    mutations: {
        /* eslint-disable no-param-reassign */
        setList: (state, {
            receivedList,
            type,
        }) => {
            if (type === 'teaor25List') {
                state.lists.teaorList = receivedList['2008'];
                state.lists.teaor25List = receivedList['2025'];
            } else if (type === 'allampolgarsagList') {
                state.lists.allampolgarsagList = receivedList;
                state.lists.allampolgarsag2List = [
                    { key: null, value: 'Nincs' },
                    ...receivedList
                ];
            } else {
                state.lists[type] = receivedList;
            }
        },
        /* eslint-enable no-param-reassign */
    },

    actions: {
        getList: (context, type) => {
            if (context?.state?.lists[type].length === 0) {
                if (generatedLists.indexOf(type) > -1) {
                    context.commit('setList', {
                        receivedList: generateList(type),
                        type,
                    });
                } else {
                    listService.getList(type)
                        .then((response) => {
                            const domain = String(window.location.pathname);
                            const receivedList = response.data;
                            if (type === 'titulusList') {
                                receivedList[0].value = '';
                            }
                            if (type === 'szerzodoNemList') {
                                if (domain.includes('baleset') || domain.includes('gap')) {
                                    for (let ii = 0; ii < receivedList.length; ii += 1) {
                                        if (
                                            receivedList[ii].value !== 'férfi'
                                            && receivedList[ii].value !== 'nő'
                                        ) {
                                            receivedList[ii].value = 'jogi személy';
                                            break;
                                        }
                                    }
                                }
                            }
                            context.commit('setList', {
                                receivedList: response.data,
                                type,
                            });
                        });
                }
            }
        },
    },
};
